import * as React from "react";
import { getBaseUrl } from "src/utils/url";
import Error from "./error";
import Auth from "../../services/auth";

interface Props {
    children?: React.ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        // eslint-disable-next-line no-console
        console.log(error);
        // eslint-disable-next-line no-console
        console.log(errorInfo.componentStack);
        try {
            fetch(`${getBaseUrl()}/api/error`, {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer b09b0ebd-2c81-4d25-a164-8d5fc8467c19`,
                },
                body: JSON.stringify({
                    error: error?.message,
                    stack: errorInfo?.componentStack,
                    orgId: Auth.user?.orgId,
                    userId: Auth.user?.id,
                    email: Auth.user?.email,
                }),
            });
        } catch (_e) {
            //
        }
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;
        if (hasError) {
            // You can render any custom fallback UI
            return <Error />;
        }

        return children;
    }
}

export default ErrorBoundary;
